/**
 * Detect "email already registered" from Supabase without treating every 400/422 as that case.
 */
export function isEmailAlreadyRegisteredError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as { message?: string; code?: string; status?: number | string };
  const code = String(err.code || '').toLowerCase();
  if (
    code === 'email_already_exists' ||
    code === 'user_already_registered' ||
    code === 'email_exists'
  ) {
    return true;
  }
  const msg = (err.message || '').toLowerCase();
  return (
    msg.includes('user already registered') ||
    msg.includes('email already exists') ||
    msg.includes('already registered') ||
    msg.includes('user already exists') ||
    msg.includes('email address is already registered')
  );
}
